import { useState } from 'react';

type ReturnValues = [boolean, { toggle: () => void; reset: () => void }];

export default (initialValue = false): ReturnValues => {
  const [on, setIsOn] = useState(initialValue);

  const toggle = () => setIsOn(on => !on);

  const reset = () => setIsOn(initialValue);

  return [on, { toggle, reset }];
};
